import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination, SearchResults } from '@uncinc/react-searchkit';

import EventCard from '../../../EventCard';
import hitTagMapper from '../../../SearchAllContent/helpers/hitTagMapper';
import { SearchTopicalEventHit } from '../../types';
import SearchErrorState from '../../../Search/ErrorState';

const SearchTopicalResultsEvents: React.FC = () => {
  const { t } = useTranslation();

  const classNames = c('SearchTopical__Results--Events');

  return (
    <div className={classNames}>
      <h2 className="mb-0">{t('components.search_topical.results.events')}</h2>

      <SearchErrorState>
        <SearchResults
          renderItem={(hit: SearchTopicalEventHit) => {
            const themeTags = hit.theme?.[0] ? hitTagMapper(hit.theme, 'theme') : [];
            const typeTags = hit.event_type?.[0] ? hitTagMapper(hit.event_type, 'article-type') : [];
            const tags = themeTags.concat(typeTags);
            const firstUpcomingStartDate = hit.computed_first_upcoming_start_date[0];
            const firstUpcomingDateIndex = hit.computed_first_upcoming_date_index[0];
            const isInfinite = hit.event_date_infinite.includes(true);

            // Specify that date is UTC by appending +00:00 at the end
            const toUtcDate = (utcDate: string | number) => new Date(`${utcDate}+00:00`);

            let startDate: Date | null = null;
            let endDate: Date | null = null;

            if (firstUpcomingStartDate) {
              // Computed doesn't need toUtcDate, it already knows
              const upcomingStartDate = new Date(firstUpcomingStartDate);
              startDate = upcomingStartDate;

              if (isInfinite) {
                // Infinite events: calculate end date by adding the original event duration.
                const originalStart = new Date(hit.event_date[0]);
                const originalEnd = new Date(hit.event_date_end_value[0]);
                const duration = originalEnd.getTime() - originalStart.getTime();
                const upcomingEndDate = upcomingStartDate.getTime() + duration;
                endDate = toUtcDate(upcomingEndDate);
              } else {
                // Regular events: use event_date_end_value directly.
                const endDateString = hit.event_date_end_value[firstUpcomingDateIndex];
                endDate = endDateString ? toUtcDate(endDateString) : null;
              }
            }

            return (
              <EventCard
                title={hit.page_title[0]}
                tags={tags}
                link={hit.url[0]}
                startDate={startDate}
                image={hit.image_style_uri?.[0]}
                endDate={endDate}
                hasMultipleDates={
                  hit.event_date_infinite.includes(true) || hit.event_date.length >= 2
                }
              />
            );
          }}
        />

        <div className="mt-4">
          <SearchPagination
            previousLabel={t('buttons.previous')}
            nextLabel={t('buttons.next')}
          />
        </div>
      </SearchErrorState>
    </div>
  );
};

export default SearchTopicalResultsEvents;
